import { Box, IBoxProps } from 'native-base';
import React from 'react';

interface LateralBarProps extends IBoxProps {}

export const LateralBar: React.FC<LateralBarProps> = ({ ...props }) => {
  return <Box position={'absolute'} top={0} left={0} bottom={0} w={'4px'} {...props} />;
};
